import React from 'react';

import { Box, Flex, Image, Paper, PaperProps, Space, Text } from '@mantine/core';
import { IconPhotoOff } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface StoreProductTileProps extends PaperProps {
  title: string;
  imgUrl: string;
  variantCount: number;
}

export function StoreProductTile({ title, imgUrl, variantCount, ...paperProps }: StoreProductTileProps) {
  const { t } = useTranslation();

  return (
    <Paper p={6} withBorder {...paperProps}>
      <Flex direction="row" align="center" justify="space-between">
        <Flex direction="row" align="center">
          <Space w={10} />
          <Image width={30} height={30} src={imgUrl} withPlaceholder placeholder={<IconPhotoOff />} />
          <Space w={10} />
          <Box maw={600}>
            <Text lineClamp={2}>{title}</Text>
          </Box>
        </Flex>
        <Flex direction="row" align="center" mr={5}>
          <Text size="md" lineClamp={2} color="dimmed" fz={'0.85rem'}>
            {t('STORES.PRODUCTS.VARIANTS', { count: variantCount })}
          </Text>
        </Flex>
      </Flex>
    </Paper>
  );
}
